import React, { useState, useEffect } from 'react';
import Note from 'components/Note';
import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
//import Dropdown from 'components/Dropdown';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';
import { useSwipeable } from 'react-swipeable';
import statusMap from 'constants/statusMap'
import { NotesContainer, NavigatorContainer, Navigator } from './styles';

const StatusHistory = ({ roomStatusHistories }) => {

  // const [period, setPeriod ] = useState('This week')

  // let filteredArray
  // switch(period) {
  //   case 'This week': 
  //     filteredArray = roomStatusHistories.filter(roomStatusRecord => moment(roomStatusRecord.createdAt).tz(TIME_ZONE) > moment().tz(TIME_ZONE).startOf('week'))
  //     break
  //   default:
  //     filteredArray = roomStatusHistories
  // }
  const [pageNumber, setPageNumber] = useState(1)
  const pageSize = 4
  const pageCount = Math.ceil(roomStatusHistories?.length/pageSize)

  useEffect(() => {
    setPageNumber(1)
  }, [roomStatusHistories])

  const paginate = (array, page_size, page_number) => {
    // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
    return array.slice((page_number - 1) * page_size, page_number * page_size);
  }

  const previousPage = () => {
    if(pageNumber > 1) {
      setPageNumber((pageNumber) => pageNumber-1)
    }
  }

  const nextPage = () => {
    if(pageNumber < pageCount) {
      setPageNumber((pageNumber) => pageNumber+1)
    }
  }

  const handles = useSwipeable({
    onSwipedLeft: () => nextPage(),
    onSwipedRight: () => previousPage(),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  })

  return (
    <Card>
      <CardHeader
        additionalstyle={`
          margin-bottom: 10px;
        `}
      >
        <div className="cardTitle">STATUS HISTORY</div>
        {/* <div className="buttonContainer">
          <div className="subTitle">VIEW TIME PERIOD</div>
          <Dropdown
            mainPage
            options={["This week"]}
            value={period}
            onChange={(e) => setPeriod(e)}
            additionalstyle={`
              width: 130px;
            `}
          />
        </div> */}
      </CardHeader>
      {/* {filteredArray.length > pageSize ? ( */}
      {roomStatusHistories.length > pageSize ? (
        <NavigatorContainer>
          <Navigator
            disabled={pageNumber <= 1}
            onClick={previousPage}
          >
            {"<"} Back
          </Navigator>
          <Navigator
            disabled={pageNumber >= pageCount}
            onClick={nextPage}
          >
            Next {">"}
          </Navigator>
          {/* <Swiper
                disabled={pageNumber<=1}
              >
                {'<'}
              </Swiper>
              <Swiper>
                SWIPE
              </Swiper>
              <Swiper
                disabled={pageNumber>= filteredArray.length/pageSize}
              >
                {'>'}
              </Swiper> */}
        </NavigatorContainer>
      ) : null}
      <NotesContainer {...handles}>
        {roomStatusHistories.length ? (
          (paginate(
            roomStatusHistories,
            pageSize,
            pageNumber
          ) || []).map((history, index) => (
            <Note
              key={history.roomStatusHistoryId}
              date={moment(history.createdAt).tz(TIME_ZONE).format("MMM Do YYYY h:mm A")}
              description={`Marked as ${statusMap[history.status]}`}
              disabled
            />
          ))
        ) : (
          <Note description="No status history yet" disabled />
        )}
      </NotesContainer>
    </Card>
  );
};

export default StatusHistory;
